//
// SelectDefinitionPanel
//
// Select a definition to use in a filter, by searching for a definition.

import { observer } from 'mobx-react-lite'
import { useState } from 'react'
import { useStore } from '../stores'

import { Spacer, VScrollView, VView } from '../appview'
import {
    Header,
    Item,
    Menu,
    MenuItem,
    Property,
    SearchInput,
    Text,
} from '../components'
import { sortItems } from '../stores/data/utils'
import { normalize } from '../utils/text'
import { ItemTitle } from '../workspaces/components'

export const SelectDefinitionPanel = observer(function SelectDefinitionPanel({
    selected,
    onSelectDefinition,
}) {
    const { app, data, view } = useStore()
    const worksheet = view.pimworksheet
    const language = worksheet.environment.get('language')

    const [searchtext, setSearchtext] = useState('')
    const [selecteditem, setSelecteditem] = useState(selected)
    let selection_in_results = false // initially

    let searchresultdefinitions = Array.from(data.definitions.entries())
    searchresultdefinitions = searchresultdefinitions.filter(
        ([key, definition]) => !definition.is_working_copy && !definition.is_extended
    )

    if (searchtext.length) {
        const searchwords = normalize(searchtext).split(' ')
        searchresultdefinitions = searchresultdefinitions.filter(
            ([key, definition]) => {
                // do a match: in label and name, label only current language
                // first, normalize (validName)
                // second, split on spaces
                // then, match all words
                let definitionlabel = definition.label.get(language)
                if (!definitionlabel || !definitionlabel.length) {
                    definitionlabel = definition.name
                }
                definitionlabel = normalize(definitionlabel)
                for (const word of searchwords) {
                    if (!word.length) continue
                    if (
                        !definitionlabel.includes(word) &&
                        !definition.name.includes(word)
                    ) {
                        return false
                    }
                }
                return true
            }
        )
    }

    searchresultdefinitions.sort(
        sortItems(language, worksheet.environment.get('labelView'))
    )

    const onSearchinputChange = event => {
        setSearchtext(event.target.value)
    }
    const onSearchinputBlur = event => {
        setSearchtext(event.target.value.trim())
    }

    const _onSelectDefinition = () => {
        onSelectDefinition && selecteditem && onSelectDefinition(selecteditem)
    }

    const searchresults = searchresultdefinitions.length ? (
        searchresultdefinitions.map(([key, definition]) => {
            if (selecteditem === key) selection_in_results = true
            return (
                <Item
                    key={key}
                    selected={selecteditem === key}
                    onClick={() => setSelecteditem(key)}
                    onDoubleClick={() => {
                        setSelecteditem(key)
                        _onSelectDefinition()
                    }}
                >
                    <ItemTitle item={definition} ellipsisAfter={24} />
                </Item>
            )
        })
    ) : (
        <div style={{ padding: '2px 5px' }}>{app.text('No matches')}</div>
    )

    const selecteddefinition = selection_in_results
        ? data.definitions.get(selecteditem)
        : null
    let selecteddefinition_info
    if (selecteddefinition) {
        let definitionname = selecteddefinition.label.get(language)
        if (!definitionname || !definitionname.length) {
            definitionname = selecteddefinition.name
        }
        selecteddefinition_info = (
            <>
                <Property className="nobreak" label={app.text('name')}>
                    <Text className="user-select" title={selecteddefinition.name}>
                        {selecteddefinition.name}
                    </Text>
                </Property>
                <Property label={app.text('label')}>
                    <Text className="user-select" title={definitionname}>
                        {definitionname}
                    </Text>
                </Property>
            </>
        )
    }

    return (
        <VView className="actions-panel select-definition-panel">
            <div className="inspector">
                <Header>{app.text('Select definition')}</Header>
                <VView
                    style={{
                        marginLeft: 5,
                        marginRight: 5,
                        marginBottom: 2,
                    }}
                >
                    <SearchInput
                        value={searchtext}
                        placeholder={app.text('Search by name or label')}
                        onChange={onSearchinputChange}
                        onBlur={onSearchinputBlur}
                    />
                    <VScrollView
                        className="search-results"
                        style={{ backgroundColor: 'white' }}
                    >
                        {searchresults}
                    </VScrollView>
                    <Spacer size={5} />
                    {selecteddefinition_info}
                </VView>
            </div>
            <Menu>
                <MenuItem
                    disabled={!selection_in_results}
                    onClick={_onSelectDefinition}
                >
                    {selecteddefinition ? (
                        <>
                            {app.text('Select definition ')}
                            <ItemTitle item={selecteddefinition} />
                        </>
                    ) : (
                        app.text('Select definition')
                    )}
                </MenuItem>
            </Menu>
        </VView>
    )
})
